export default (...paths) => paths.join('/').replace(/\/\/+/g, '/')
